// based on vc-dialog 7.5.14
import DialogWrap from './DialogWrap';
export default DialogWrap;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-dialog/index.js
// module id = 798
// module chunks = 0